import { BehaviorSubject, Observable } from 'rxjs';
import * as uuid from 'uuid';

export class TranslationModel {
    id: string = uuid.v4();
    originalContent: string = '';
    translatedContent: string = '';
    private isTranslationSubject = new BehaviorSubject<boolean>(false);
    isTranslating$: Observable<boolean> = this.isTranslationSubject.asObservable();

    setIsTranslating(isTranslating: boolean): void {
        this.isTranslationSubject.next(isTranslating);
    }
}
